import req from './request'

const DEFAULT_ENDPOINTS = {
    noComplete: '/dumpsPhotocontrol/marketing/no-complete',
    Complete: '/dumpsPhotocontrol/marketing/complete',
    Statistic: '/dumpsPhotocontrol/marketing/statistic',
    calling: '/dumpsPhotocontrol/calling',
    driver: '/dumpsPhotocontrol/driver-info/general',
    promotion: '/dumpsPhotocontrol/driver-info/promotions',
    toWork: '/dumpsPhotocontrol/driver-info/to-work',
    comments: '/dumpsPhotocontrol/driver-info/comments',
    addcomment: '/dumpsPhotocontrol/driver-info/add-comment',
    assetCall: '/dumpsPhotocontrol/asset-call',
    detail: '/dumpsPhotocontrol/marketing/statistic/detail',
    regcalling: '/dumpsRegistered/calling'
}

export default {
    noComplete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.noComplete, param)
    },
    complete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Complete, param)
    },
    statistic(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Statistic, param)
    },
    calling(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.calling, param)
    },
    driver(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driver, param)
    },
    promotion(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.promotion, param)
    },
    toWork(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.toWork, param)
    },
    comments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.comments, param)
    },
    addcomment(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.addcomment, param)        
    },
    assetCall(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.assetCall, param)
    },
    detail(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.detail, param)
    },
    regcalling(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.regcalling, param)
    }
}